<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}新闻分类`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="800px"
        :before-close="close">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="分类名称">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
           <!-- <el-form-item label="分类标识">
                <el-input v-model="form.flag"></el-input>
            </el-form-item> -->

            <span  class="fx fx-center">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </el-form>

    </el-drawer>

</template>


<style scoped>
    .fx-c_stretch .pic_item {
        width: 40%;
        height: 200px;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;
    }
    .pic_item img {
        width: 100%;
        height: 100%;
    }

    /* .bottom {
        height: 80px;
    }
    .bottom > * {
        margin: 0 20px;
    } */
    .fx-c_stretch .del_btn {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 30px;
        color: rgb(22, 21, 21);
    }
    .del_btn:hover {
        color: var(--primary);
    }
    .upload_btn {
        border: 1px dashed var(--primary);
        border-radius: 10px;
        cursor: pointer;
    }
</style>
<script>


    export default {
        props: [
            "item",
        ],

        data() {
            return {
                show: false,
                form: {...this.item},
            }
        },
        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                if (this.form.name == "") {
                   this.$showError("请输入分类名称再保存");
                   return;
                }
                if (this.form.flag == "") {
                   this.$showError("请选择分类标识再保存");
                   return;
                }
                this.$ajaxPost("/articleType/save", {
                    articleType:this.form
                }, data => {
                    this.$emit("submit", data.result);
                    this.$emit("close");
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
        }
    }
</script>
